<template>
  <div class="sideRight">
    <div>
      <div class="part1" v-if="$store.state.gameType != 2">
        <div>
          <div class="toSearch" v-if="searchFlag" @click="toSearch">
            <span></span>
            <p>搜索</p>
          </div>
        </div>
        <div
          class="toUpload"
          v-if="uploadFlag && $route.name != 'guidePage'"
          @click="toUpload"
        >
          <p><strong>+</strong> 發布帖子</p>
        </div>
      </div>
      <div
        class="part2"
        v-if="$route.name != 'guidePage' && $store.state.gameType != 2"
      >
        <h2>
          <span></span>
          版主
        </h2>
        <ul>
          <li
            v-for="item in followsList"
            :key="item.id"
            @click="goUserPage(item.id)"
          >
            <div class="userInfo_leftbox_imgbox">
              <img :src="item.avatar" @error="defImg()" alt="" />
              <div class="userInfo_leftbox_img_icon"></div>
            </div>
            <p>{{ item.nick_name }}</p>
            <span
              :class="item.isFollow == 1 ? 'follow' : ''"
              @click.stop="focusClick(item)"
              >{{ item.isFollow == 1 ? '已关注' : '关注' }}</span
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import * as _code from '../utils/code';
import get from '@/api/get';
import { Toast } from 'vant';
export default {
  name: 'sideRight',
  data() {
    return {
      defaultImg:
        this.$store.state.gameType != 1
          ? 'https://media.tentree-games.com/media/pictures/community/img/header.webp'
          : 'https://media.zlongame.com/media/pictures/cn/community/img/lzg_header.png',
      followsList: [], //推荐
      searchFlag: true,
      uploadFlag: true
    };
  },
  async mounted() {
    if (this.$store.state.token == '') {
      const promise = new Promise((resolve) => {
        this.resolveHander = resolve;
      });
      await promise;
    }
    this.init();
  },
  watch: {
    '$store.state.token'(token) {
      if (token != '') {
        this.resolveHander && this.resolveHander();
      }
    }
  },
  methods: {
    init() {
      let _path = this.$route.path;
      if (_path.indexOf('search') > 0) {
        this.searchFlag = false;
      }
      if (_path.indexOf('postPage') > 0) {
        this.uploadFlag = false;
      }
      get.webmaster().then((res) => {
        let _data = res.data;
        if (_data.code == 0) {
          this.followsList = _data.data;
        } else {
          // this.errorMessage(_data);
        }
      });
    },
    defImg() {
      //图片错误展示默认图片
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    //去用户主页
    goUserPage(id) {
      if (this.$store.state.loginStatus == 1) {
        this.$router.push({
          name: 'otherHome',
          query: { id: id, newpage: true, pageNo: 1 }
        });
      } else {
        this.$store.commit('changeLoginShow', true);
      }
    },
    //关注&&取消关注
    focusClick(item) {
      get.follow(item.id).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          item.isFollow = !item.isFollow;
          // if (item.isFollow) {
          //   Toast("关注成功");
          // } else {
          //   Toast("已取消关注");
          // }
          this.init();
          this.firstLoad();
        } else {
          this.errorMessage(data);
        }
      });
    },
    toSearch() {
      if (this.$store.state.loginStatus == 1) {
        this.$router.push({ name: 'search', query: {} });
      } else {
        this.$store.commit('changeLoginShow', true);
      }
    },
    toUpload() {
      if (this.$store.state.loginStatus == 0) {
        this.$store.commit('changeLoginShow', true);
      } else {
        if (this.$store.state.postingFlag) {
          this.$router.push({
            name: 'postPage',
            query: {}
          });
        } else {
          Toast('功能维护中，暂不支持发帖');
        }
      }
    },
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  }
};
</script>
<style scoped></style>